import React, { useEffect, useState } from 'react'
import useTrans from '@hooks/useTrans'
import { cn } from '@utils/safeTs'

export const ENTER = 'Enter'

const FormTextarea = ({
  name = undefined,
  placeholder = undefined,
  disabled = false,
  value = '',
  onBlur = undefined,
  onFocus = undefined,
  onChange,
  preventKeys = [],
  label = undefined,
  id,
  maxLength = undefined,
  rows = undefined,
  className = undefined,
}) => {

  const t = useTrans()
  const [maxLengthMessage, setMaxLengthMessage] = useState('')

  useEffect(() => {
    setMaxLengthMessage('')
    setTimeout(() => {
      setMaxLengthMessage(
        t(maxLength - (value || '').length === 1 
          ? "{0} carattere rimanente" 
          : "{0} caratteri rimanenti", [(maxLength - (value || '').length).toString()])
      )
    }, 1500)
  }, [value])

  return (
    <>
    {label && <span className={'formtextarea__label'}>{label}</span>}
    <textarea
      name={name}
      value={value}
      onBlur={onBlur}
      onFocus={onFocus}
      onChange={(e) => {
        if (preventKeys?.includes(ENTER)) {
          e.target.value = e.target.value.replace(/\n/g, ' ')
        }
        onChange(e)
      }}
      onKeyPress={(e) => {
        if (preventKeys?.includes(e.key)) {
          e.preventDefault()
        }
      }}
      maxLength={maxLength}
      className={`formtextarea formfield__input ${className}`}
      disabled={disabled}
      placeholder={placeholder ? placeholder : ''}
      id={id}
      rows={rows} 
    ></textarea>
    {!!maxLength && (
      <>
        <div className={cn("formtextarea__counter", (value || '').length === maxLength ? "formtextarea__counter--alert" : '')}>
          {(value || '').length} / {maxLength}
        </div>
        <div className="formtextarea__counter-live" aria-live='polite'>
          {maxLengthMessage}
        </div>
      </>
    )}
    </>
  )
}

export default FormTextarea
